import React from 'react';
import DriveEasyEyePlayer from '../components/DriveEasyEyePlayer';

/**
 * DriveEasy Eye - Live Camera Page
 * Now powered by WebRTC for low-latency streaming.
 */
const Eye = () => {
    return (
        <div className="w-screen h-screen bg-black overflow-hidden relative">
            <DriveEasyEyePlayer deviceId="AICAM1" />
        </div>
    );
};

export default Eye;
